export default __webpack_public_path__ + "static/media/ocean_waves.b23a1db4.png";